 
const intervalTimer = () => {
    
    let timerInterval = null;

    function startTimer() {
        const intervalTime = 1560000;
        timerInterval = setInterval(() => {
            postMessage('timerCompleted');
        }, intervalTime);
    }

    function stopTimer() {
        if (timerInterval) {
            clearInterval(timerInterval);
            timerInterval = null;
        }
    }

    onmessage = function (event) {
        const action = event.data
        if (action === 'start') {
            startTimer();
        }
        if (action === 'stop') {
            stopTimer();
        }
    }
}

let code = intervalTimer.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"))
const blob = new Blob([code], { type: 'application/javascript' })
const workerScript = URL.createObjectURL(blob)
export default workerScript;